import { useAppRouter as o } from "../../components/providers/AppRouterProvider/AppRouterProvider.js";
import { setRumViewName as n } from "../../helpers/rum.helper.js";
import { useEffect as p } from "react";
var f = () => {
  const { getCurrent: e, onRouteChange: m } = o();
  p(() => {
    const r = (t) => {
      t?.name && n(t.name);
    };
    return r(e()), m(r);
  }, [e, m]);
};
export {
  f as useRumViewNames
};

//# sourceMappingURL=useRumViewNames.js.map